
import Container from './Container';

function Root(props: any) {
    return (
        <Container {...props} />
    );
}

export default Root;
